class AlertService {
    static error(msg, title = 'Oops!', tempo = 10000) {
        window.$.gritter.add({
            title: title,
            text: msg,
            time: tempo,
            class_name: 'erro'
        });
    }
    ;
    static success(msg, title = 'Sucesso!', tempo = 5000) {
        window.$.gritter.add({
            title: title,
            text: msg,
            time: tempo,
            class_name: 'sucesso'
        });
    }
    ;
    static warning(msg, title, tempo = 5000) {
        window.$.gritter.add({
            title: title,
            text: msg,
            time: tempo,
            class_name: 'warning'
        });
    }
    ;
}
export default AlertService;
